<style lang="scss" scoped>
.reset {
    padding: 50px 20px 0;
    width: 360px;
    box-shadow: 0 0 2px #fff;
    background-color: rgba(255, 255, 255, 0.3);
    & &-item {
        margin-bottom: 30px;
    }
    &-title {
        font-size: 20px;
        color: #fff;
    }
    &-bg {
        background: url("../image/bg.jpg") no-repeat center center/cover;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
}
</style>

<template>
    <div class="reset-bg">
        <Form
            class="reset view-center"
            :rules="rules"
            :model="formData"
            ref="formEmail"
            v-if="!isConfirm"
        >
            <h3 class="reset-title">
                <span
                    style="cursor: pointer; margin-right: 5px; font-size: 20px;"
                    @click="backToLogin"
                >
                    <Icon type="md-arrow-back" />
                </span>
                {{$t('port.login.reset_password', { defaultValue: '重置密码' })}}
            </h3>
            <FormItem style="margin-top: 15px;" v-if="resetProcess === 0">
                <Select :placeholder="$t('port.login.choose_verf_type', { defaultValue: '选择验证类型' })" v-model="formData.viaType">
                    <Option
                        v-for="item in viaTypeList"
                        :key="item.key"
                        :value="item.value"
                    >{{item.label}}</Option>
                </Select>
            </FormItem>
            <!-- 邮箱验证 -->
            <div v-if="formData.viaType === 3">
                <FormItem prop="channel" class="reset-item">
                    <Input
                        v-model="formData.channel"
                        class="width-100per"
                        :placeholder="$t('port.reset.email')"
                    >
                        <span slot="prepend">
                            <Icon size="16" type="ios-mail"></Icon>
                        </span>
                    </Input>
                </FormItem>
                <FormItem class="reset-item text-center">
                    <Button :loading="loading" type="primary" @click="submitEmail">
                        {{ $t("port.reset.submit") }}&nbsp;
                        <Icon type="ios-send" size="14"></Icon>
                    </Button>
                </FormItem>
            </div>
            <!-- 短信验证 -->
            <div v-else-if="formData.viaType === 2">
                <FormItem prop="channel" class="reset-item">
                    <Input v-model="formData.channel" class="width-100per" :placeholder="$t('port.login.phone_number', { defaultValue: '手机号' })">
                        <span slot="prepend">
                            <Icon size="16" type="ios-phone-portrait"></Icon>
                        </span>
                    </Input>
                </FormItem>
                <FormItem class="text-right">
                    <Button
                        :disabled="sendDisable"
                        :loading="loading"
                        type="success"
                        @click="sendVCode"
                    >
                        {{$t('port.login.send_text_code', { defaultValue: '发送短信验证码' })}}&nbsp;
                        <span v-if="sendDisable">({{sendNowTime}})</span>
                        <Icon type="ios-send" size="14"></Icon>
                    </Button>
                </FormItem>
                <FormItem prop="verifyToken" class="reset-item">
                    <Input v-model="formData.verifyToken" class="width-100per" :placeholder="$t('port.login.verfcode', { defaultValue: '验证码' })">
                        <span slot="prepend">
                            <Icon size="16" type="ios-information-circle-outline"></Icon>
                        </span>
                    </Input>
                </FormItem>
                <FormItem class="reset-item" prop="password">
                    <Input
                        v-model="formData.password"
                        type="password"
                        class="width-100per"
                        :placeholder="$t('port.reset.password')"
                    />
                </FormItem>
                <FormItem class="reset-item" prop="repassword">
                    <Input
                        v-model="formData.repassword"
                        type="password"
                        class="width-100per"
                        :placeholder="$t('port.reset.repassword')"
                    />
                </FormItem>
                <FormItem prop="verCode"></FormItem>
                <FormItem class="reset-item text-right">
                    <Button class="margin-left-15" :loading="loading" type="primary" @click="submitPhone">
                        {{$t('port.login.submit', { defaultValue: '提交' })}}&nbsp;
                        <Icon type="md-arrow-forward" size="14"></Icon>
                    </Button>
                </FormItem>
            </div>
        </Form>
        <Form class="reset view-center" ref="formReset" :model="formData" :rules="rules" v-else>
            <header class="reset-title">{{ $t("port.reset.title") }}</header>
            <FormItem class="reset-item" prop="password">
                <Input
                    v-model="formData.password"
                    type="password"
                    class="width-100per"
                    :placeholder="$t('port.reset.password')"
                />
            </FormItem>
            <FormItem class="reset-item" prop="repassword">
                <Input
                    v-model="formData.repassword"
                    type="password"
                    class="width-100per"
                    :placeholder="$t('port.reset.repassword')"
                />
            </FormItem>
            <FormItem class="reset-item text-center">
                <Button :loading="loading" type="primary" @click="submitReset">
                    {{ $t("port.reset.reset") }}&nbsp;
                    <Icon type="arrow-right-c"></Icon>
                </Button>
            </FormItem>
        </Form>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { HttpReset, HttpResetByToken } from "@/service/port";

export default {
    data() {
        return {
            formData: {
                channel: "",
                password: "",
                repassword: "",
            },
            sendNowTime: 0,
            sendTimeCount: 30,
            sendDisable: false,
            timeCountTimer: null,
            // 重置进度 0 未选择类型 1 已选择类型
            resetProcess: 0,
            isConfirm: false,
            loading: false,
        };
    },
    watch: {
        sendNowTime: {
            handler(val) {
                if (val === 0) {
                    this.sendDisable = false;
                } else {
                    this.sendDisable = true;
                }
            },
        },
    },
    created() {
        const query = this.$route.query;
        this.isConfirm = query.via && query.idlabel && query.verify_token;
    },
    computed: {
        ...mapState(["lang"]),
        viaTypeList() {
            return [
                {
                    value: 2,
                    label: this.$t('port.login.short_text', { defaultValue: "短信" }),
                },
                {
                    value: 3,
                    label: this.$t('port.login.email', { defaultValue: "邮箱" }),
                },
            ];
        },
        rules() {
            const isEn = this.lang === "en";
            let channel = [
                {
                    required: true,
                    message: this.$t("global.common.fill_required", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
                {
                    trigger: "blur",
                    validator: (rule, value = "", callback) => {
                        if (
                            /^[a-z\d]+(\.[a-z\d]+)*@([\da-z](-[\da-z])?)+(\.{1,2}[a-z]+)+$/.test(
                                value
                            )
                        ) {
                            callback();
                        } else {
                            callback(
                                new Error(
                                    this.$t("global.common.email", {
                                        defaultValue: "请输入email格式",
                                    })
                                )
                            );
                        }
                    },
                },
            ];
            // 短信验证
            if (this.formData.viaType === 2) {
                channel = [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                    {
                        trigger: "blur",
                        validator: (rule, value = "", callback) => {
                            if (
                                /^1\d{10}$/.test(
                                    value
                                )
                            ) {
                                callback();
                            } else {
                                callback(
                                    new Error(
                                        this.$t("global.common.phone", {
                                            defaultValue: "请输入手机格式",
                                        })
                                    )
                                );
                            }
                        },
                    },
                ];
            }
            return {
                channel: channel,
                password: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                    {
                        validator: (rule, value = "", callback) => {
                            let tip;
                            if (
                                value.length < 8 ||
                                !(/[a-z]+/i.test(value) && /\d+/.test(value))
                            ) {
                                tip = this.$t("global.password.rule", {
                                    defaultValue:
                                        "必须包含数字字母,密码长度不能少于八位",
                                });
                            }
                            callback(tip ? new Error(tip) : undefined);
                        },
                    },
                ],
                verifyToken: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                ],
                repassword: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                    {
                        validator: (rule, value = "", callback) => {
                            let tip;
                            if (
                                value.length < 8 ||
                                !(/[a-z]+/i.test(value) && /\d+/.test(value))
                            ) {
                                tip = this.$t("global.password.rule", {
                                    defaultValue:
                                        "必须包含数字字母,密码长度不能少于八位",
                                });
                            }
                            if (value !== this.formData.password) {
                                tip = this.$t("global.password.same_password", {
                                    defaultValue: "请确认密码一致",
                                });
                            }
                            callback(tip ? new Error(tip) : undefined);
                        },
                    },
                ],
            };
        },
    },
    methods: {
        backToLogin() {
            this.$router.push({ name: "login" });
        },
        sendVCode() {
            let message = false
            this.$refs.formEmail.validateField('channel', valid => {
                message = valid
            })
            if (message) return
            // 是否填写手机号
            if (!this.formData.channel)
                return this.$VMessage.error(this.$t('port.login.input_phone', { defaultValue: '请输入手机号' }));
            this.loading = true;
            HttpReset({
                via: 2,
                idlabel: this.formData.channel,
            })
                .then(
                    (res) => {
                        this.setTimeCount();
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        // 手机重置密码提交
        async submitPhone () {
            let flag = true
            await this.$refs.formEmail.validate((valid) => {
                flag = valid
            })
            if (!flag) return
            HttpResetByToken({
                via: 2,
                idlabel: this.formData.channel,
                verify_token: this.formData.verifyToken,
                password: this.formData.password
            }).then(res => {
                this.$VMessage.success(res.message)
                this.submitSuccess()
            }, err => {
                this.$VMessage.error(err.message)
            })
        },
        setTimeCount() {
            this.sendNowTime = this.sendTimeCount;
            this.timeCountTimer = setInterval(() => {
                if (this.sendNowTime === 0) {
                    return clearInterval(this.timeCountTimer);
                }
                this.sendNowTime--;
            }, 1000);
        },
        submitEmail() {
            this.$refs.formEmail.validate((valid) => {
                if (valid) {
                    const formData = this.formData;
                    this.loading = true;
                    // via 2 SMS 3 email
                    HttpReset({
                        via: formData.viaType,
                        idlabel: formData.channel,
                    }).then(
                        (res) => {
                            this.$Message.success(this.$t('port.login.email_click_next', { defaultValue: '已发送邮件，请在邮件中点击链接进行后续操作' }));
                            const timeout = setTimeout(() => {
                                this.backToLogin();
                            }, 3000);
                        },
                        (res) => {
                            this.loading = false;
                            this.$Message.error(res.message);
                        }
                    );
                }
            });
        },
        submitReset() {
            this.$refs.formReset.validate((valid) => {
                if (valid) {
                    const formData = this.formData;
                    this.loading = true;
                    HttpResetByToken({
                        ...this.$route.query,
                        password: formData.password,
                    }).then(
                        (res) => {
                            this.$VMessage.success(this.$t('port.login.reset_success', { defaultValue: '重置成功！即将跳转登录页面' }))
                            this.submitSuccess()
                        },
                        (res) => {
                            this.loading = false;
                            this.$Message.error(res.message);
                        }
                    );
                }
            });
        },
        // 重置成功后的通用处理
        submitSuccess () {
            const timeout = setTimeout(() => {
                this.backToLogin()
            }, 3000);
            this.$Message.success(res.message);
        },
    },
};
</script>
